<template>
  <div class="grid">
    <div :class="['grid__items', size === 'sm' ? 'grid__items--sm' : 'grid__items--lg']">
      <div
        v-for="resultId in displayedResults()"
        v-if="!resultId.empty"
        :key="!resultId.loading && !resultId.empty ? resultId + results.byId[resultId].attributes.licensed : 'GRID_ITEM_' + type + '_' + resultId.num"
        :class="['grid__item', !resultId.loading && !resultId.empty ? 'grid__item--' + results.byId[resultId].type : '']"
        @click="createRipple($event); !resultId.loading && !resultId.empty ? clicked({ 'id': results.byId[resultId].id, 'hash': resultId, 'type': results.byId[resultId].type }) : false"
      >
        <UtilityItem
          :resultId="!resultId.loading && !resultId.empty ? resultId : false"
          :result="!resultId.loading && !resultId.empty ? results.byId[resultId] : {}"
          :url="!resultId.loading && !resultId.empty ? '/' + results.byId[resultId].type + '/' + results.byId[resultId].id : '#'"
          :title="!resultId.loading && !resultId.empty ? results.byId[resultId].attributes.title : ''"
          :type="type"
          :size="size"
          :data="!resultId.loading && !resultId.empty ? results.byId[resultId].attributes.data_series : {}"
          :licensed="!resultId.loading && !resultId.empty ? results.byId[resultId].attributes.licensed : false"
          :trial="!resultId.loading && !resultId.empty ? results.byId[resultId].attributes.trial : false"
          :free="!resultId.loading && !resultId.empty ? results.byId[resultId].attributes.free : false"
          :loading="loading"
          :height="gridItemHeight"
          :windowWidth="windowWidth"
        />
      </div>
    </div>
  </div>
</template>

<script>
import UtilityItem from '@/components/utility/Item.vue'
import helperMethods from '@/helpers/utility.js'

export default {
  components: {
    UtilityItem
  },
  props: {
    type: {
      type: String,
      default: 'datasets'
    },
    size: {
      type: String,
      default: 'sm'
    },
    results: {
      type: Object
    },
    loading: {
      type: Boolean,
      default: true
    }
  },
  created () {
    window.addEventListener('resize', this.resize)
  },
  unmounted () {
    window.removeEventListener('resize', this.resize)
  },
  mounted () {
    this.resize()
  },
  data () {
    return {
      windowWidth: window.innerWidth
    }
  },
  computed: {
    gridItemHeight () {
      return this.$store.getters['search/getGridItemHeight']
    }
  },
  methods: {
    clicked (value) {
      let name = this.results.byId[value.hash].attributes.title ? this.results.byId[value.hash].attributes.title : (this.results.byId[value.hash].attributes.name ? this.results.byId[value.hash].attributes.name : value.id)
      if (name && name !== '') {
        this.sendGoogleAnalyticsEvent('document_' + value.type + '_open', name, 'grid', this.$store.getters['user/getSubscriptionStatus'])
      }
      this.$emit('clicked', value)
    },
    resize () {
      this.windowWidth = window.innerWidth

      if (document.getElementsByClassName('grid__item').length > 0) {
        let width = document.getElementsByClassName('grid__item')[0].clientWidth
        let height = (width * (3 / 6))
        this.$store.dispatch('search/setGridItemHeight', height)
      }
    },
    displayedResults () {
      let displayedResults = []
      let displayable = 2

      if (this.type === 'datasets') {
        if (this.windowWidth > 687) {
          displayable = 4

          if (this.windowWidth > 1008) {
            displayable = 6

            if (this.windowWidth > 1329) {
              displayable = 8
            }
          }
        }
      }

      else if (this.type === 'pdfs') {
        if (this.windowWidth > 687) {
          displayable = 3
        }
      }

      if (this.$route.name !== 'Search') {
        displayable = 24
      }

      for (let i=0; i<displayable; i++) {
        if (!this.loading && this.results && this.results.allIds[i]) {
          displayedResults.push(this.results.allIds[i])
        } else if (this.loading) {
          displayedResults.push({ 'loading': true, 'num': '_' + i })
        } else {
          displayedResults.push({ 'empty': true, 'num': '_' + i })
        }
      }

      return displayedResults
    },
    ...helperMethods
  },
  watch: {
    size: function () {
      this.$nextTick(function () {
        this.resize()
      })
    }
  }
}
</script>

<style lang="scss" scoped>
@import '@/styles/app.scss';

.grid {
  background-color: $bg-1;

  &__items {
    display: grid;
    grid-gap: 1px;

    &--sm {
      grid-template-columns: repeat(auto-fit, minmax(320px, 1fr));

      @media screen and (max-width: 687px) {
        div {
          border-left: none;
        }
      }

      @media screen and (min-width: 688px) and (max-width: 1008px) {
        :nth-child(odd) {
          border-left: none;
        }
      }

      @media screen and (min-width: 1009px) and (max-width: 1329px) {
        :first-child, :nth-child(4), :nth-child(7), :nth-child(10), :nth-child(13), :nth-child(16), :nth-child(19), :nth-child(22) {
          border-left: none;
        }
      }

      @media screen and (min-width: 1330px) {
        :first-child, :nth-child(5), :nth-child(9), :nth-child(13), :nth-child(17), :nth-child(21) {
          border-left: none;
        }
      }
    }

    &--lg {
      grid-template-columns: repeat(auto-fit, minmax(420px, 1fr));

      @media screen and (max-width: 887px) {
        div {
          border-left: none;
        }
      }

      @media screen and (min-width: 888px) and (max-width: 1308px) {
        :nth-child(odd) {
          border-left: none;
        }
      }

      @media screen and (min-width: 1309px) {
        :first-child, :nth-child(4), :nth-child(7), :nth-child(10), :nth-child(13), :nth-child(16), :nth-child(19), :nth-child(22) {
          border-left: none;
        }
      }
    }
  }

  &__item {
    display: flex;
    position: relative;
    overflow: hidden;
    background-color: $bg-4;
    //padding: 8px;
    border-top: 1px solid rgba($white, 0.1);
    border-left: 1px solid rgba($white, 0.1);
    //width: 100%;
    //max-width: 33vw; // TODO: Smarter + mobiletweaks

    &:hover {
      background-color: $bg-2;
    }
  }
}

</style>
